import { authRoles } from '../../../auth/authRoles'
import RecetasGestion from './view/RecetasGestion'
import { lazy } from 'react'

const RecetaRegistroApp = lazy(() => import('./view/RecetasRegistro'))
const RecetasActualizarApp = lazy(() => import('./view/RecetasActualizar'))

export const recetasRoutesMap = {
  gestion: {
    path: '/recetas/gestion',
    name: 'Gestión de Recetas',
  },
  registro: {
    path: '/recetas/registro',
    name: 'Registro de Recetas',
  },
  actualizar: {
    path: '/recetas/actualizar/:id',
    name: 'Actualizar Recetas',
  },
}

const recetasRoutes = [
  {
    path: recetasRoutesMap.gestion.path,
    element: <RecetasGestion />,
    auth: authRoles.admin,
  },
  {
    path: recetasRoutesMap.registro.path,
    element: <RecetaRegistroApp />,
    auth: authRoles.admin,
  },
  {
    path: recetasRoutesMap.actualizar.path,
    element: <RecetasActualizarApp />,
    auth: authRoles.admin,
  },
]
export default recetasRoutes
